import { style } from '@vanilla-extract/css';

import { blockquoteFigure } from './BlockquoteFigure.css';

export const quoteCaptionContainer = style({
  selectors: {
    [`${blockquoteFigure['1']} &`]: {
      textAlign: 'var(--wt-quote-byline-alignment, left)',
      paddingTop: 'var(--wt-quote-byline-padding-top, var(--wt-quote-byline-spacing, 0px))',
      paddingBottom: 'var(--wt-quote-byline-padding-bottom, 0px)',
    },
    [`${blockquoteFigure['2']} &`]: {
      textAlign: 'var(--wt-quote-2-byline-alignment, left)',
      paddingTop: 'var(--wt-quote-2-byline-padding-top, var(--wt-quote-2-byline-spacing, 0px))',
      paddingBottom: 'var(--wt-quote-2-byline-padding-bottom, 0px)',
    },
    [`${blockquoteFigure['3']} &`]: {
      textAlign: 'var(--wt-quote-3-byline-alignment, center)',
      paddingTop: 'var(--wt-quote-3-byline-padding-top, var(--wt-quote-3-byline-spacing, 0px))',
      paddingBottom: 'var(--wt-quote-3-byline-padding-bottom, 0px)',
    },
  },
});

export const quoteCaption = style({
  selectors: {
    [`${blockquoteFigure['1']} ${quoteCaptionContainer} &`]: {
      color: 'var(--wt-quote-byline-color, #000000)',
      fontSize: 'var(--wt-quote-byline-font-size, 14px)',
      fontFamily: 'var(--wt-quote-byline-font-family, Arial)',
      fontWeight: 'var(--wt-quote-byline-font-weight)',
    },
    [`${blockquoteFigure['2']} ${quoteCaptionContainer} &`]: {
      color: 'var(--wt-quote-2-byline-color, #000000)',
      fontSize: 'var(--wt-quote-2-byline-font-size, 14px)',
      fontFamily: 'var(--wt-quote-2-byline-font-family, Arial)',
      fontWeight: 'var(--wt-quote-2-byline-font-weight)',
    },
    [`${blockquoteFigure['3']} ${quoteCaptionContainer} &`]: {
      color: 'var(--wt-quote-3-byline-color, #000000)',
      fontSize: 'var(--wt-quote-3-byline-font-size, 14px)',
      fontFamily: 'var(--wt-quote-3-byline-font-family, Arial)',
      fontWeight: 'var(--wt-quote-3-byline-font-weight)',
    },
  },
});
